import { ConfigurationTypes } from '../const/ConfigurationTypes';
import IBetConfig from './contracts/configurations/IBetConfig';
import IBuyFeatureConfig from './contracts/configurations/IBuyFeatureConfig';
import IConfiguration from './contracts/configurations/IConfiguration';
import ISceneSpineAnimConfig from './contracts/configurations/ISceneSpineAnimConfig';
import ISettingsConfig from './contracts/configurations/ISettingsConfig';
import ISceneViewConfig from './contracts/configurations/scene_view/ISceneViewConfig';
import ISpineWinSymbolViewConfig from './contracts/configurations/ISpineWinSymbolViewConfig';
import ISymbolSpineAnimConfig from './contracts/configurations/ISymbolSpineAnimConfig';
import ILocalConfig from './contracts/configurations/ILocalConfig';
import IAdvanceGeneralGameConfig from './contracts/configurations/game/IAdvanceGeneralGameConfig';
import IErrorConfig from './contracts/configurations/IErrorConfig';
import IJackpotBannerConfig from './contracts/configurations/IJackpotBannerConfig';
import ConsoleUtil from '../utils/ConsoleUtil';
import IVendorServerConfig from '../server/configs/IVendorServerConfig';
import IComponentsConfig from '../managers/contracts/configurations/IComponentsConfig';
import IReelsConfig from '../managers/contracts/configurations/IReelsConfig';

class ConfigManager {
    private _configs: Map<ConfigurationTypes, IConfiguration> = new Map();
    private _oldConfigurationVersion: Object = null;

    /**
     * Return one of the Configurations declared in ConfigurationTypes
     * @param configType one of  "ConfigurationTypes"
     */
    getConfig<T extends ISceneSpineAnimConfig>(configType: ConfigurationTypes.SPINE_ANIMATIONS): T;
    getConfig<T extends ISymbolSpineAnimConfig>(configType: ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS): T;
    getConfig<T extends IBetConfig>(configType: ConfigurationTypes.BET): T;
    getConfig<T extends ISettingsConfig>(configType: ConfigurationTypes.SETTINGS): T;
    getConfig<M extends IAdvanceGeneralGameConfig<T>, T>(configType: ConfigurationTypes.GAME): M;
    getConfig<T extends ISpineWinSymbolViewConfig>(configType: ConfigurationTypes.WIN_SYMBOL_SPINE_ANIMATIONS): T;
    getConfig<T extends IBuyFeatureConfig>(configType: ConfigurationTypes.BUY_FEATURE): T;
    getConfig<T extends ILocalConfig>(configType: ConfigurationTypes.LOCAL): T;
    getConfig<T extends ILocalConfig>(configType: ConfigurationTypes.GAME): T;
    getConfig<T extends IConfiguration>(configType: ConfigurationTypes.GAME_SPECIFIC): T;
    getConfig<T extends IErrorConfig>(configType: ConfigurationTypes.ERROR): T;
    getConfig<T extends IVendorServerConfig>(configType: ConfigurationTypes.VENDOR_SERVER): T;
    getConfig<T extends IJackpotBannerConfig>(configType: ConfigurationTypes.JACKPOT_BANNER): T;
    getConfig<T extends ISceneViewConfig>(configType: ConfigurationTypes.SCENE_VIEW): T;
    getConfig<T extends IComponentsConfig>(configType: ConfigurationTypes.COMPONENTS): T;
    getConfig<T extends IReelsConfig>(configType: ConfigurationTypes.REEL): T;
    public getConfig(configType: ConfigurationTypes): IConfiguration {
        let result = null;
        if (this._configs.has(configType)) {
            result = this._configs.get(configType)
        } else {
            // result = this._oldConfigurationVersion;
            ConsoleUtil.warn(
                `[CONFIGURATION MANAGER] -> configuration with type: <${configType}>, has not a registered in ConfigManager.
                 return deprecated game-config json file`,
                {
                    registeredConfigurations: this._configs.keys()
                }
            );
        }

        return result
    }

    /**
     * Return "true" if this config type is registered in Configuration manager and "false" if not
     */
    public hasConfig(configType: ConfigurationTypes): boolean {
        return this._configs.has(configType)
    }
    private setConfig(configType: ConfigurationTypes, config: IConfiguration): void {
        if (this._configs.has(configType)) {
            ConsoleUtil.warn(
                `[CONFIGURATION MANAGER] -> configuration with type:  <${configType}>, already registered in ConfigManager`,
                this._configs.get(configType)
            );
        } else {
            this._configs.set(configType, config)
        }
    }

    public registerConfigs(data: IConfiguration[]): void {
        data.forEach(config => {
            this.setConfig(config.type, config)
        })
    }

    public setDeprecateConfig(data: Object) {
        this._oldConfigurationVersion = data;
    }
}

export default new ConfigManager()
